import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	gallery: null,
	error: false,
	loading: true
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			case types.FETCH_PRODUCT_GALLERY_LOADING:
				return INITIAL_STATE;

			case types.FETCH_PRODUCT_GALLERY_SUCCESS:
				draft.gallery = action.payload;
				draft.loading = false;
				return;

			case types.FETCH_PRODUCT_GALLERY_ERROR:
				draft.loading = false;
				draft.error = true;
				return;

			case types.CLEAR_PRODUCT_GALLERY:
				return INITIAL_STATE;

			default:
				return state;
		}
	});
